<template>
  <div>
    <h1>关于页面</h1>
    <router-link to="/">回首页</router-link>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>
